export const LOGO_ICON = (
  <svg xmlns="http://www.w3.org/2000/svg" width="21.309" height="21" viewBox="0 0 22 21" fill="none">
    <path
      d="M12.4124 19.4535C12.127 19.3584 11.6513 19.3346 11.247 19.6675C10.8427 19.3346 10.3671 19.3584 10.0817 19.4535C9.84387 19.5486 9.65361 19.5962 9.29688 19.5962C9.65361 20.3097 10.3909 20.8091 11.247 20.8091C12.1032 20.8091 12.8405 20.3097 13.1972 19.5962C12.8405 19.5962 12.6502 19.5248 12.4124 19.4535Z"
      fill="white"
    />
    <path
      d="M11.2015 0C5.32717 0 0.546875 4.75651 0.546875 10.6308C0.546875 15.6727 4.04291 19.8822 8.75186 21C5.018 19.0023 3.49591 14.4122 5.30339 10.5832C5.58878 12.1053 6.58764 13.4609 8.06216 14.1506C6.13578 9.65572 7.56273 4.35221 11.5344 1.42695C10.7496 4.0906 11.9387 6.5402 14.531 8.39524C17.4801 10.5119 17.599 14.8403 15.0067 17.171C16.0293 16.9332 17.0044 16.3624 17.7179 15.4824C17.266 17.7656 15.8391 19.8347 13.6511 21C18.36 19.906 21.856 15.6727 21.856 10.6308C21.856 4.75651 17.0758 0 11.2015 0Z"
      fill="white"
    />
  </svg>
);
